import { get, put, Delete, post } from '../axios'


// 获取映射表列表
export const getMappingform = (params) => post('/web/mapping/get', params)

// 查看映射表详情
export const viewValueMappingform = (params) => get('/web/mapping/valuemapping/view/' + params)
export const viewBitMappingform = (params) => get('/web/mapping/bitmapping/view/' + params)

// 创建映射表
export const createValueMappingform = (data) => post('/web/mapping/valuemapping/create', data)
export const createBitMappingform = (data) => post('/web/mapping/bitmapping/create', data)

// 更新映射表
export const updateValueMappingform = (data) => put('/web/mapping/valuemapping/update', data)
export const updateBitMappingform = (data) => put('/web/mapping/bitmapping/update', data)

// 删除映射表
export const deleteMappingform = (data) => Delete('/web/mapping/delete?ids='+ data)

// 获取映射表名称列表
export const getMappingformName = (params) => get('/web/mapping/name', params)
